<template>
  <div class="d-block">
    <!-- <span class="line" /> -->
    <div class="grid">
      <a
        v-for="({url, filled, title}, index) in filledSteps"
        :key="index"
        :href="url"
        class="circle"
        :title="title"
        :class="{ 'isFilled': filled }"
        :disabled="!filled"
      >
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeachersFormStep',
  props: {
    filledSteps: Array
  }
}
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  max-width: 400px;
  margin: 0 auto;
  align-items: center;
  margin-bottom: 30px;

  .circle {
    width: 20px;
    height: 20px;
    border: 1px solid #FD8204;
    border-radius: 20px;
    margin: 0 auto;
    box-sizing: border-box;
    position: relative;

    &:first-child:before, &:last-child:after {
      height: 0px;
      width: 0px;
    }

    &:before {
      content: " ";
      display: block;
      position: absolute;
      height: 1px;
      background: #FD8204;
      width: calc(100% + 30px);
      right: 100%;
      top: calc(50%);

      @media (min-width: 380px) {
        width: calc(100% + 40px);
      }
      @media (min-width: 420px) {
        width: calc(100% + 50px);
      }
    }

    &:after {
      content: " ";
      display: block;
      position: absolute;
      height: 1px;
      background: #FD8204;
      width: 100%;
      left: 100%;
      top: calc(50%);
    }
  }

  .isFilled {
    background-color: #FD8204;
  }
}

// .line {
//   border: 1px solid #FD8204;
//   width: 320px;
//   display: block;
//   position: absolute;
//   top: 10px;
//   left: 215px;
// }

// .d-block {
//   display: block;
// }
</style>



// WEBPACK FOOTER //
// resources/js/views/TeachersForm/Forms/Steps.vue